import { BehaviorSubject } from 'rxjs';
import { ECHATMETHOD } from '../../../shared/core-types/chat.enum';

/**
 * Represents a chat event delivered over the event bus.
 *
 * @remarks
 * Emitted by ChatSocket notification handlers to inform the UI/state layer about
 * incoming server-side events (e.g., message updates, status changes).
 */
export interface IchatEvent {

  /**
   * The type of the chat event.
   */
  type: ECHATMETHOD;

  /**
   * The data associated with the chat event.
   *
   * @remarks
   * Shape depends on the specific {@link ECHATMETHOD}.
   */
  data?;

  /**
   * The error message associated with the chat event.
   */
  error?: string;
}

/**
 * Represents an outgoing UI-originated event.
 *
 * @remarks
 * Used to signal outbound actions to consumers (e.g., messages viewed/read receipts).
 */
export interface IoutEvent {

  /**
   * The type of the out event.
   */
  type: 'viewed';

  /**
   * The data associated with the out event.
   */
  data?;

  /**
   * The error message associated with the out event.
   */
  error?: string;
}

/**
 * Represents a socket event.
 *
 * @deprecated Legacy interface; scheduled for removal. Use {@link IchatEvent} instead.
 */
// TODO TO REMOVE
export interface IsocketEvent {
  type: string;
  data?;
  error?: string;
}

/**
 * Centralized event bus for chat-related communications.
 *
 * @remarks
 * Provides reactive streams to decouple socket-level events from application consumers.
 * Consumers typically subscribe to `chat$` to receive {@link IchatEvent}s.
 *
 * @example
 * const bus = new Eventbus();
 * const sub = bus.chat$.subscribe(evt => {
 *   if (!evt) return;
 *   console.log('Chat event:', evt.type, evt.data);
 * });
 * // later
 * sub.unsubscribe();
 */
export class Eventbus {
  // TODO TO REMOVE socket$ = new BehaviorSubject<IsocketEvent | null>(null);
  /** Stream of chat events coming from the server via ChatSocket. */
  chat$ = new BehaviorSubject<IchatEvent | null>(null);
  // userOnlineChange$ = new BehaviorSubject<boolean | null>(null);
  /** Stream for UI-originated outbound events (e.g., read/view acknowledgements). */
  outEvent$ = new BehaviorSubject<IoutEvent | null>(null);

  constructor() { }
}
